import { TRANSACTION_STATES } from '../constants';
import makeBikeTypeNameSelector from './makers/makeBikeTypeNameSelector';

const root = state => state.order.transaction;

export const transactionSelector = state => root(state).item;

export const transactionIsLoadingSelector = state => !!root(state).isFetching;

export const transactionIsReloadingSelector = state =>
  transactionIsLoadingSelector(state) && !!transactionSelector(state);

const StatusMapping = {
  processing: TRANSACTION_STATES.PROCESSING,
  paid: TRANSACTION_STATES.PAID,
  error: TRANSACTION_STATES.ERROR
};

export const transactionStateSelector = state => {
  const transaction = transactionSelector(state);

  // transaction was not loaded yet
  if (!transaction) {
    return null;
  }

  const {
    isConfirmationNeeded,
    status
  } = transaction;

  if (isConfirmationNeeded) {
    return TRANSACTION_STATES.CONFIRMATION;
  }

  const byStatus = StatusMapping[status];

  if (byStatus) {
    return byStatus;
  }

  throw new Error(`Unknown transaction status ${status}`);
};

export const transactionBikeTypeNameSelector = makeBikeTypeNameSelector(state => {
  const transaction = transactionSelector(state);

  if (!transaction) {
    return;
  }

  return transaction.order.bikeType;
});

export const transactionInfoSelector = state => {
  const transaction = transactionSelector(state);

  if (!transaction) {
    return;
  }

  return {
    ...transaction,
    order: {
      ...transaction.order,
      bikeTypeName: transactionBikeTypeNameSelector(state)
    }
  };
};



// WEBPACK FOOTER //
// ./src/selectors/transaction.js